import React from 'react';
import { FormattedMessage } from 'react-intl';
import Divider from '@bibliocommons/divider';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import {
  FullScreenOverlayBody,
  FullScreenOverlayHeader,
  FullScreenOverlayContent
} from '@bibliocommons/base-full-screen-overlay';
import { BibBriefContainer } from 'app/components/bibs/shared/BibBrief';
import MetadataDisplay from 'app/components/bibs/shared/MetadataDisplay';
import { ChevronLink } from '@bibliocommons/base-links';
import { sendAnalyticsEvents } from '@bibliocommons/utils-analytics';
import { bibMetadataEventComposer } from '@bibliocommons/analytics-event-composers';
import AnalyticsConstants from '@bibliocommons/constants-analytics';

import './FullDetails.scss';

const { composeMetadataLinkClickEvent } = bibMetadataEventComposer;
const { CUSTOM_DIMENSIONS } = AnalyticsConstants;

const handleClickEvent = category => field => {
  sendAnalyticsEvents(
    composeMetadataLinkClickEvent({
      fieldName: field.get('fieldName'),
      category,
      gtmContainerName: CUSTOM_DIMENSIONS.CONTAINER_NAMES.BIB_ABOUT_OVERLAY
    })
  );
};

export default class FullDetails extends React.PureComponent {
  categoriesInOrder() {
    const { catalogBib } = this.props;
    const fields = catalogBib.get('fields');

    const sortingOrder = [
      'DETAILS',
      'AUDIENCE',
      'SERIES',
      'CONTRIBUTORS',
      'CONTAINS',
      'SUBJECTGENRE',
      'RELATED',
      'NOTES',
      'CALLCLASS',
      'IDENTIFIERS'
    ];

    const sortedFields = fields.sortBy(field => sortingOrder.indexOf(field.get('category')));
    return sortedFields;
  }

  renderContent() {
    const orderedFields = this.categoriesInOrder();

    return orderedFields.map(field => {
      const sectionLabelId = `bib_metadata_category_${field.get('category').toLowerCase()}`;
      if (field.get('category') === 'ABOUT') {
        return null;
      }

      return (
        <div key={field.get('category')}>
          <Divider />
          <div className="field-detail">
            <FormattedMessage className="field-detail-label" tagName="h3" id={sectionLabelId} />
            <MetadataDisplay fields={field.get('items')} handleClick={handleClickEvent(field.get('category'))} />
          </div>
        </div>
      );
    });
  }

  renderLinkToMarcPage() {
    return (
      <ChevronLink
        href={`/v2/record/${this.props.catalogBib.get('metadataId')}/originalrecord`}
        dataKey="original-record-link"
      >
        <FormattedMessage id="original_record" />
      </ChevronLink>
    );
  }

  render() {
    const metadataId = this.props.catalogBib.get('metadataId');

    return (
      <FullScreenOverlayBody className="cp-full-details">
        <FullScreenOverlayHeader title={<FormattedMessage id="full_details" />} />
        <FullScreenOverlayContent size="medium">
          <div className="full-details-brief">
            <BibBriefContainer metadataId={metadataId} />
          </div>
          {this.renderContent()}
          <Divider />
          {this.renderLinkToMarcPage()}
        </FullScreenOverlayContent>
      </FullScreenOverlayBody>
    );
  }
}

FullDetails.propTypes = {
  catalogBib: catalogBibShape.isRequired
};
